module.exports = __webpack_public_path__ + "img/close.b6315346.svg";